import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface tableOfContentsState {
  chapterToRemind: string;
  expandedIndex: string;
  clickedOnNavBar: string;
}

const initialState: tableOfContentsState = {
  chapterToRemind: '',
  expandedIndex: '',
  clickedOnNavBar: '',
};

const tableOfContentsSlice = createSlice({
  name: 'tableOfContentsSlice',
  initialState,
  reducers: {
    setChapterToRemind: (state, action: PayloadAction<tableOfContentsState['chapterToRemind']>) => {
      return { ...state, chapterToRemind: action.payload };
    },
    setExpandedIndex: (state, action: PayloadAction<tableOfContentsState['expandedIndex']>) => {
      return { ...state, expandedIndex: action.payload };
    },
    setClickedOnNavgationBarIndex: (
      state,
      action: PayloadAction<tableOfContentsState['clickedOnNavBar']>
    ) => {
      return { ...state, clickedOnNavBar: action.payload };
    },
    resetTableOfContentsSlice: () => {
      return initialState;
    },
  },
});

export const {
  setChapterToRemind,
  resetTableOfContentsSlice,
  setExpandedIndex,
  setClickedOnNavgationBarIndex,
} = tableOfContentsSlice.actions;

export const { reducer: tableOfContentsReducer } = tableOfContentsSlice;
